import { createFileRoute } from "@tanstack/react-router";
import { FINANCE_TABS, FinancePage, type FinanceTab } from "@/features/finance/FinancePage";

export const Route = createFileRoute("/_app/finance/$tab")({ component: Page });

function Page() {
  const { tab } = Route.useParams();
  return <FinancePage tab={(FINANCE_TABS as readonly string[]).includes(tab) ? (tab as FinanceTab) : "pnl"} />;
}
